import React, { Fragment, /* useContext, */ useState } from 'react';
/*
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
*/
import DeviceAdminListView from "./DeviceAdminListView";
import DeviceAdminDetailsView from "./DeviceAdminDetailsView";
import DeviceAdminNewView from "./DeviceAdminNewView";


const DeviceAdmin = () => {

/*
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
*/

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
/*
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
*/


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <DeviceAdminListView    pageState={pageState} onUIMode={setUIMode}
                                                        onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <DeviceAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <DeviceAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default DeviceAdmin;
